import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueStartDateInvalidWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.issue-start-date.invalid');
    }
}
